<template>
    <div class="tooltip--wrapper" v-bind:class="tid" v-on-click-outside="close">
        <div class="tooltip--container"
             v-bind:class="{ 'tooltip--container__active': active }"
             ref="container"
             v-bind:style="{marginTop: containerMargin}"
        >
            <div class="tooltip--cross" @click="toolTipToggle"></div>
            <h1 class="tooltip--title">{{label}}</h1>
            <div class="tooltip--message">
                <slot></slot>
            </div>
            <div class="tooltip--arrow" v-bind:style="{left: containerArrowLeft}"></div>
            <div class="tooltip--arrow--mask" v-bind:style="{left: containerArrowLeft}"></div>
        </div>
        <div class="tooltip--label" @click="toolTipToggle" ref="label">{{label}}</div>
    </div>
</template>

<script>
    import { mixin as onClickOutside } from 'vue-on-click-outside';
    export default {
        props: {
            label: {
                type: String,
                required: true
            },
            tid: {
                type: String
            }
        },
        mixins: [onClickOutside],
        data() {
            return {
                active: false,
                containerMargin: 0,
                containerArrowLeft: 0
            };
        },
        mounted() {
            let containerLabelOffset = (window.innerWidth < 660) ? this.$refs.label.offsetLeft : 0;
            this.containerMargin = ( - (this.$refs.container.clientHeight + 20) ) + 'px';
            this.containerArrowLeft = ( (this.$refs.label.clientWidth / 2 ) - 15 ) + containerLabelOffset + 'px';
        },
        methods: {
            toolTipToggle () {
                this.active = !this.active;
            },
            close () {
                this.active = false;
            }
        }
    };
</script>
